import React from 'react';
import { FiExternalLink, FiMessageCircle } from 'react-icons/fi';
import { User } from '../../types';
import { getDiscordInviteForPlan, isDiscordPlan } from '../../utils/discordInvites';

type DiscordOnboardingProps = {
  user: User;
};

const DiscordOnboarding: React.FC<DiscordOnboardingProps> = ({ user }) => {
  const plan = String(user.plan || '').toLowerCase();
  const inviteUrl = getDiscordInviteForPlan(plan);

  if (!isDiscordPlan(plan) || !inviteUrl) {
    return (
      <div className="rounded-2xl border border-border bg-surface p-5 sm:p-8 text-center">
        <p className="text-sm text-muted">
          Discord onboarding is available for Growth, General, and Pro plans.
        </p>
      </div>
    );
  }

  const planLabel = plan.charAt(0).toUpperCase() + plan.slice(1);

  return (
    <div className="mx-auto max-w-2xl space-y-6 animate-fadeIn">
      <div className="space-y-2">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#5865F2]">
          Onboarding
        </p>
        <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">Discord</h2>
        <p className="text-muted">
          Join the onboarding session on Discord to set up Webull for your {planLabel} plan.
        </p>
      </div>

      <div className="rounded-2xl border border-border bg-surface-elevated p-4 sm:p-6 shadow-sm">
        <div className="flex items-start gap-3 sm:gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#5865F2]/15 text-[#5865F2]">
            <FiMessageCircle className="h-6 w-6" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-lg font-bold text-foreground">Webull setup session</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted">
              Please join the onboarding session on Discord to set up Webull. Our team will guide
              you through connecting your broker and getting started.
            </p>
            <a
              href={inviteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[#5865F2] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#4752C4]"
            >
              <FiExternalLink className="h-4 w-4" />
              Open Discord invite
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscordOnboarding;
